const surveillanceReducer = (
  state = {
    loading: false,
    retryLoading: false,
    pictureApprovalLoading: false,
    reference: null,
    forceReferenceUpdate: false,
    captures: {},
    pendingCaptures: {},
    status: null,
    devices: null,
    liveFeedAutoSwitch: null
  },
  action
) => {
  switch (action.type) {
    case "SET_SURVEILLANCE_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_SURVEILLANCE_RETRY_LOADING":
      return {
        ...state,
        retryLoading: action.payload.loading
      };

    case "SET_SURVEILLANCE_PICTURE_APPROVAL_LOADING":
      return {
        ...state,
        pictureApprovalLoading: action.payload.loading
      };

    case "SET_REFERENCE_PICTURE":
      return {
        ...state,
        reference: action.payload.data
      };

    case "SET_REFERENCE_PICTURE_ASSET":
      return {
        ...state,
        reference: { ...state.reference, ...action.payload.data }
      };

    case "SET_FORCE_REFERENCE_PICTURE_UPDATE":
      return {
        ...state,
        forceReferencePictureUpdate: action.payload.update 
      };

    case "SET_CAPTURED_PICTURE":
      return {
        ...state,
        captures: { ...state.captures, ...action.payload.data }
      };

    case "SET_CAPTURED_PICTURE_ASSET":
      return {
        ...state,
        captures: {
          ...state.captures,
          [action.payload.employeeId]: {
            ...state.captures[action.payload.employeeId],
            ...action.payload.data
          }
        }
      };

    case "SET_PENDING_CAPTURED_PICTURE":
      return {
        ...state,
        pendingCaptures: { ...state.pendingCaptures, ...action.payload.data }
      };

    case "SET_PENDING_CAPTURED_PICTURE_ASSET":
      return {
        ...state,
        pendingCaptures: {
          ...state.pendingCaptures,
          [action.payload.employeeId]: {
            ...state.pendingCaptures[action.payload.employeeId],
            ...action.payload.data
          }
        }
      };

    case "SET_PICTURE_STATUS":
      return {
        ...state,
        status: { ...state.status, ...action.payload.data }
      };

    case "SET_DEVICES":
      return {
        ...state,
        devices: action.payload.data
      };

    case "PUT_LIVE_FEED_AUTO_SWITCH_TIME":
      return {
        ...state,
        liveFeedAutoSwitch: action.payload.time
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};
export default surveillanceReducer;
